<template>
  <div class="fillcontain">
    <head-top></head-top>

    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true">
          <el-form-item >
            <el-cascader
              @change="change"
              :options="options"
              v-model="selectedOptions">
            </el-cascader>
          </el-form-item>
          <el-form-item style="float:right">
            <el-button type="primary" @click="addmaterial">添加素材</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index" width="70">
        </el-table-column>
        <el-table-column
          label="素材名称"
          prop="materialName">
        </el-table-column>
        <el-table-column
          label="分类"
          prop="primaryTypeName">
        </el-table-column>
        <el-table-column
          label="子目录"
          prop="secondTypeName">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="创建时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="Modmaterial(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getcourseification,getMaterial,getDelMaterial } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        limit: 20,
        total: 0,
        tableData: [],
        options:[],
        selectedOptions:[],
        currentPage: 1,
        formLabelWidth:'120px',
      }
    },
    components: {
      headTop,
    },
    methods: {
      //时间戳转换
      formatDate:function (value){
        let dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      //  二级联动查询接口
      getInterface() {
        let params = {
          category: 2,
        };
        getcourseification(params).then(res => {
          this.options = res
          this.selectedOptions = [res[0].value,res[0].children[0].value]
          this.selectedOptions[1] = res[0].children[0].value
          this.change()
        }).catch(error => {
          console.log(error)
        })
      },
      //分类查询
      change(){
        let params={
          pageNum:1,
          pageSize:this.limit,
          typeId:this.selectedOptions[1]
        };
        //获取排版管理列表
        getMaterial(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
          this.currentPage = res.pageNum
        }).catch(error=>{
          console.log(error);
        })
      },
      changes(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          typeId:this.selectedOptions[1]
        };
        getMaterial(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
          this.currentPage = res.pageNum
        }).catch(error=>{
          console.log(error);
        })
      },
      //分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.changes()
      },
      //跳转新增页面
      addmaterial(){
        this.$router.push({
          path: 'addText',
        });
      },
      //跳转编辑页面
      Modmaterial(index, row){
        this.$router.push({
          path: 'materialInfo',
          query:{
            materialId:row.materialId,
            parentId:row.parentId,
            typeId:row.typeId,
          }
        });
      },
      //删除
      handleDelete(index, row){
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            materialId:row.materialId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getDelMaterial(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
    },
    activated(){
      this.getInterface()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
    float:right;
  }

</style>



// WEBPACK FOOTER //
// src/page/materrial.vue